<template>
  <div>
    <b-row v-if="checkAccessPrivilege('Payment.Whitelist.Withdraw.Search')">
      <b-col sm="12" md="12">
        <b-card no-body>
          <b-card-header>
              <h5 class="float-left"><i class='fa fa-search'></i> Search</h5>
          </b-card-header>
          <b-card-body>
            <b-form inline>
              <label class="mr-sm-2" for="sUsername">Username </label>
              <b-input id="sUsername" type="text" placeholder="" v-model.trim="sUsername"></b-input>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <label class="mr-sm-2" for="sPeriod">Date Period </label>
              <b-form-select id="sPeriod" :plain="true" :options="period" v-model="sPeriod" text-field="value" value-field="key">
                <template slot="first">
                  <option :value="null">-- Please select an option --</option>
                </template>
              </b-form-select>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <b-button variant="primary" :disabled="$v.sUsername.$invalid || $v.sPeriod.$invalid" @click="getWithdrawRecord"><i class="fa fa-search"></i> Search</b-button>
            </b-form>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="12" md="12">
        <b-card no-body>
          <b-card-header>
              <h3 class="float-left"><i class='fa fa-bank'></i> Withdraw Record List</h3>
          </b-card-header>
          <b-card-body>
            <b-table :hover="hover" :striped="striped" :bordered="bordered" :small="small" :fixed="fixed" responsive="sm" :items="items" :fields="fields" :current-page="currentPage" :per-page="perPage">
            </b-table>
            <nav>
              <b-pagination :total-rows="getRowCount(items)" :per-page="perPage" v-model="currentPage" prev-text="Prev" next-text="Next" hide-goto-end-buttons/>
            </nav>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
  // import VueNotifications from 'vue-notifications'
  // import {Events} from '../../../../events.js'
  const {required, minLength, maxLength} = require('vuelidate/lib/validators')
  export default {
    name: 'withdraw-record-table',
    props: {
      caption: {
        type: String,
        default: 'Table'
      },
      hover: {
        type: Boolean,
        default: false
      },
      striped: {
        type: Boolean,
        default: false
      },
      bordered: {
        type: Boolean,
        default: false
      },
      small: {
        type: Boolean,
        default: false
      },
      fixed: {
        type: Boolean,
        default: false
      }
    },
    data: () => {
      return {
        items: [],
        members: [],
        period: [
          {key: 'today', value: 'Today'},
          {key: 'yesterday', value: 'Yesterday'},
          {key: 'month', value: 'This Month'},
          {key: 'past60days', value: 'Past 60 days'}
        ],
        fields: [
          {key: 'Username', label: 'Username'},
          {key: 'AddTime', label: 'Add Time'},
          {key: 'OrderNumber', label: 'Order Number'},
          {key: 'TransferAmount', label: 'Transfer Amount'},
          {key: 'WithdrawBankName', label: 'WIthdraw Bank Name'},
          {key: 'WithdrawBankAccount', label: 'Withdraw Bank Account'},
          {key: 'RemitAccountName', label: 'Remit Account Name'},
          {key: 'Memo', label: 'Memo'}
        ],
        currentPage: 1,
        perPage: 50,
        sPeriod: null,
        sUsername: ''
      }
    },
    validations: {
      sUsername: { required, minLength: minLength(5), maxLength: maxLength(20) },
      sPeriod: { required }
    },
    watch: {
      currentPage: function () {
        this.getWithdrawRecord()
      }
    },
    methods: {
      getRowCount (items) {
        return items.length
      },
      async getWithdrawRecord () {
        try {
          let username = this.sUsername
          let period = this.sPeriod
          let result = await this.$http.get(this.API_ENDPOINT + `/payment/record/withdraw/getRecord?username=${username}&period=${period}`, { header: { 'Content-Type': 'application/json' } })
          this.items = result.data.result
        } catch (err) {
          console.lgo(err)
        }
      },
      checkAccessPrivilege (module) {
        if (!module) return true
        return this.PRIVILEGE.includes(module)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/payment/records/withdraw/WithdrawRecordsTable.vue